class PlanOptionSelector {
  
  selected_plan=null;
  selected_variant=null;
  plan_duration=null;
  plan_type=null;
  plan_summary=null;
  product_plan_details = [];
  types = [];

  constructor() {
    this.orderPath = document.querySelector(".order-button")?.href;
    this.product_plan_details = window.plan_details.filter(plan=>plan.handle==current_product && plan.snacks == 0);
    this.types = this.product_plan_details.map(plan=>plan.type);
    this.selected_plan = this.product_plan_details.find(plan=>{
      return plan.duration == "7 Days" && (plan.type == "Full Program" || (!this.types.includes("Full Program") && plan.type == "Lunches & Dinners"));
    });
    this.selected_variant = this.selected_plan.id;
    this.plan_duration = this.selected_plan.duration;
    this.plan_type = this.selected_plan.type;
    this.plan_summary = this.selected_plan.includes;

    this.setupEvents();
    this.render();
  }

  setupEvents() {
    document.querySelectorAll('[data-type]').forEach(element=>{
      element.addEventListener("click",event=>{
        this.update_type(event.srcElement);
      });
    });

    document.querySelectorAll("[data-duration]").forEach(checkbox=>{
      checkbox.addEventListener("click",event=>{
        this.update_duration(event.srcElement.getAttribute("data-duration"));
      });
    });
  }

  render() {
    if (document.querySelector(".js-variant-id"))
      document.querySelector(".js-variant-id").value = this.selected_plan.id;
    if (document.querySelector("input#selling_plan"))
      document.querySelector("input#selling_plan").value = this.selected_plan.selling_plan_id;
    document.querySelector(".js-program-title").innerHTML = this.selected_plan.type;
    document.querySelector(".js-program-contents").innerHTML = this.selected_plan.includes;
    document.querySelector(".js-regular-price").innerHTML = `$${(parseFloat(this.selected_plan.compare_at)).toFixed(2)}`;
    document.querySelector(".js-discount-price").innerHTML = `$${(parseFloat(this.selected_plan.price)).toFixed(2)}`;
    document.querySelector(".js-savings-amount").innerHTML = `$${(parseFloat(this.selected_plan.savings)).toFixed(2)}`;
    document.querySelector(".js-go-cart-add-to-cart")?.setAttribute('data-sku', this.selected_plan.sku);
    document.querySelector(".js-go-cart-add-to-cart")?.setAttribute('data-price', this.selected_plan.price);
    if (document.querySelector(".order-button")) {
      this.planSku = this.selected_plan.sku.split("-").reverse();
      document.querySelector(".order-button").href = this.orderPath + "#" + this.selected_plan.handle + "&" + this.planSku[0] + "_" + this.planSku[1];
    }
  }

  select_program(id) {
    this.selected_plan = this.product_plan_details.find(program=>{
      return program.type==this.plan_type && program.duration==this.plan_duration;
    });
    this.render();
  }

  update_duration(d) {
    this.plan_duration = d;
    this.select_program();
  }

  update_type(d) {
    var el = document.querySelector(`input[data-type]:checked`);
    this.plan_type = el.getAttribute("data-type");
    this.select_program();
  }
}

window.addEventListener("DOMContentLoaded",event=>{
	const selector = new PlanOptionSelector();
});
